import { useState, useEffect, useCallback, useRef } from "react";
import LoginScreen from "./LoginScreen";
import EnvSelector from "./EnvSelector";
import ModeChoice from "./ModeChoice";
import HistoryPanel from "./HistoryPanel";
import OneDashPanel from "./OneDashPanel";
import FSAOneDashPanel from "./FSAOneDashPanel";
import KafkaPanel from "./KafkaPanel";
import RedisPanel from "./RedisPanel";
import MqttPanel from "./MqttPanel";
import DockerPanel from "./DockerPanel";
import HomePanel from "./HomePanel";
import UserPanel from "./UserPanel";
import ServerMetrics from "./ServerMetrics";
import AlertsPanel from "./AlertsPanel";
import DBPanel from "./DBPanel";
import FSADBPanel from "./FSADBPanel";
import AIAssistantPanel from "./AIAssistantPanel";
import AssetsPanel from "./AssetsPanel";
import DeployPanel from "./DeployPanel";

// ── THEMES ──────────────────────────────────────────────
const THEMES = {
  midnight: { label:"🌙 Midnight Blue",
    bg:"#0a0f1e",bgCard:"#0d1526",bgHover:"rgba(59,130,246,0.05)",bgSelected:"rgba(59,130,246,0.08)",
    topbar:"#0d1526",border:"#1e2a45",borderAccent:"rgba(59,130,246,0.4)",
    text:"#e2e8f0",textSub:"#94a3b8",textMuted:"#64748b",textFaint:"#1e2a45",
    badge:"rgba(30,42,69,0.8)",metricsBg:"#0d1a30",summaryBg:"rgba(13,26,48,0.8)",
    logBg:"#060c18",scrollThumb:"#1e2a45",inputBg:"rgba(30,42,69,0.6)",
  },
  slate: { label:"🌌 Slate Dark",
    bg:"#1a1f2e",bgCard:"#1e2438",bgHover:"rgba(129,140,248,0.05)",bgSelected:"rgba(129,140,248,0.08)",
    topbar:"#1e2438",border:"#2a3045",borderAccent:"rgba(129,140,248,0.4)",
    text:"#e2e8f0",textSub:"#94a3b8",textMuted:"#64748b",textFaint:"#2a3045",
    badge:"rgba(42,48,69,0.8)",metricsBg:"#151a28",summaryBg:"rgba(21,26,40,0.8)",
    logBg:"#10131e",scrollThumb:"#2a3045",inputBg:"rgba(42,48,69,0.6)",
  },
  cyberpunk: { label:"⚡ Cyberpunk",
    bg:"#0d0d14",bgCard:"#12121e",bgHover:"rgba(250,204,21,0.04)",bgSelected:"rgba(250,204,21,0.08)",
    topbar:"#12121e",border:"#2a2a3e",borderAccent:"rgba(250,204,21,0.5)",
    text:"#fafafa",textSub:"#a1a1aa",textMuted:"#52525b",textFaint:"#2a2a3e",
    badge:"rgba(42,42,62,0.8)",metricsBg:"#0a0a12",summaryBg:"rgba(10,10,18,0.8)",
    logBg:"#08080f",scrollThumb:"#2a2a3e",inputBg:"rgba(42,42,62,0.5)",
  },
  volcano: { label:"🌋 Volcano",
    bg:"#130a08",bgCard:"#1c100d",bgHover:"rgba(239,68,68,0.05)",bgSelected:"rgba(239,68,68,0.08)",
    topbar:"#1c100d",border:"#3d1a14",borderAccent:"rgba(239,68,68,0.4)",
    text:"#fef2f2",textSub:"#fca5a5",textMuted:"#991b1b",textFaint:"#3d1a14",
    badge:"rgba(61,26,20,0.8)",metricsBg:"#110908",summaryBg:"rgba(17,9,8,0.8)",
    logBg:"#0a0605",scrollThumb:"#3d1a14",inputBg:"rgba(61,26,20,0.5)",
  },
  forest: { label:"🌿 Forest",
    bg:"#0a130a",bgCard:"#0d1a0d",bgHover:"rgba(34,197,94,0.05)",bgSelected:"rgba(34,197,94,0.08)",
    topbar:"#0d1a0d",border:"#1a3a1a",borderAccent:"rgba(34,197,94,0.4)",
    text:"#f0fdf4",textSub:"#86efac",textMuted:"#4ade80",textFaint:"#1a3a1a",
    badge:"rgba(26,58,26,0.8)",metricsBg:"#081008",summaryBg:"rgba(8,16,8,0.8)",
    logBg:"#060e06",scrollThumb:"#1a3a1a",inputBg:"rgba(26,58,26,0.5)",
  },
  ocean: { label:"🌊 Ocean",
    bg:"#03111f",bgCard:"#051828",bgHover:"rgba(6,182,212,0.05)",bgSelected:"rgba(6,182,212,0.08)",
    topbar:"#051828",border:"#0c2a40",borderAccent:"rgba(6,182,212,0.4)",
    text:"#ecfeff",textSub:"#67e8f9",textMuted:"#164e63",textFaint:"#0c2a40",
    badge:"rgba(12,42,64,0.8)",metricsBg:"#030f1a",summaryBg:"rgba(3,15,26,0.8)",
    logBg:"#020c16",scrollThumb:"#0c2a40",inputBg:"rgba(12,42,64,0.5)",
  },
  aurora: { label:"🌈 Aurora",
    bg:"#080a14",bgCard:"#0e1020",bgHover:"rgba(167,139,250,0.05)",bgSelected:"rgba(167,139,250,0.08)",
    topbar:"#0e1020",border:"#1e1a3a",borderAccent:"rgba(167,139,250,0.4)",
    text:"#faf5ff",textSub:"#c4b5fd",textMuted:"#6d28d9",textFaint:"#1e1a3a",
    badge:"rgba(30,26,58,0.8)",metricsBg:"#060810",summaryBg:"rgba(6,8,16,0.8)",
    logBg:"#04060c",scrollThumb:"#1e1a3a",inputBg:"rgba(30,26,58,0.5)",
  },
  tech: { label:"💻 Tech Green",
    bg:"#000d00",bgCard:"#001400",bgHover:"rgba(0,255,65,0.04)",bgSelected:"rgba(0,255,65,0.07)",
    topbar:"#001400",border:"#003300",borderAccent:"rgba(0,255,65,0.4)",
    text:"#00ff41",textSub:"#00cc33",textMuted:"#006600",textFaint:"#003300",
    badge:"rgba(0,51,0,0.8)",metricsBg:"#000a00",summaryBg:"rgba(0,10,0,0.8)",
    logBg:"#000800",scrollThumb:"#003300",inputBg:"rgba(0,51,0,0.5)",
  },
  light: { label:"☀️ Pure White",
    bg:"#f8fafc",bgCard:"#ffffff",bgHover:"rgba(0,0,0,0.02)",bgSelected:"rgba(37,99,235,0.06)",
    topbar:"#ffffff",border:"#e2e8f0",borderAccent:"rgba(37,99,235,0.3)",
    text:"#0f172a",textSub:"#334155",textMuted:"#94a3b8",textFaint:"#e2e8f0",
    badge:"#f1f5f9",metricsBg:"#f8fafc",summaryBg:"#f1f5f9",
    logBg:"#f8fafc",scrollThumb:"#e2e8f0",inputBg:"#f1f5f9",
  },
  rose: { label:"🌸 Rose",
    bg:"#fff1f5",bgCard:"#ffffff",bgHover:"rgba(244,63,94,0.04)",bgSelected:"rgba(244,63,94,0.08)",
    topbar:"#ffffff",border:"#fecdd3",borderAccent:"rgba(244,63,94,0.3)",
    text:"#4c0519",textSub:"#9f1239",textMuted:"#be123c",textFaint:"#fecdd3",
    badge:"#fff1f2",metricsBg:"#fff1f5",summaryBg:"#fff1f2",
    logBg:"#fff1f5",scrollThumb:"#fecdd3",inputBg:"#fff1f2",
  },
  neumorph: { label:"◐ Neumorphism",
    bg:"#dfe4ec",bgCard:"#eaeff6",bgHover:"rgba(2,132,199,0.06)",bgSelected:"rgba(2,132,199,0.12)",
    topbar:"#dfe4ec",border:"#b4bece",borderAccent:"rgba(2,132,199,0.5)",
    text:"#0f172a",textSub:"#334155",textMuted:"#64748b",textFaint:"#b4bece",
    badge:"#eaeff6",metricsBg:"#e8edf5",summaryBg:"#eaeff6",
    logBg:"#f0f4f9",scrollThumb:"#b4bece",inputBg:"#d6dce6",
  },
  neumorphdark: { label:"◑ Neumorphism Dark",
    bg:"#282b33",bgCard:"#32363f",bgHover:"rgba(14,165,233,0.1)",bgSelected:"rgba(14,165,233,0.16)",
    topbar:"#282b33",border:"#1c1f25",borderAccent:"rgba(56,189,248,0.6)",
    text:"#f8fafc",textSub:"#cbd5e1",textMuted:"#94a3b8",textFaint:"#1c1f25",
    badge:"#32363f",metricsBg:"#2e3139",summaryBg:"#32363f",
    logBg:"#232630",scrollThumb:"#1c1f25",inputBg:"#2e313a",
  },
};


const SERVERS = {
  home:   { label:"🏠 Home",           tag:"HOME", url:"",                                   accent:"#06b6d4" },
  db:     { label:"🗄 DB Cluster",   tag:"DB",    url:"/db-api",     accent:"#10b981", isDB:true },
  fsadb:  { label:"🗄 FSA DB Cluster", tag:"FSA-DB", url:"/fsadb-api",  accent:"#14b8a6", isDB:true },
  dev:    { label:"sit-script-device",          tag:"DEV",   url:"/dev-api",    accent:"#06b6d4" },
  prod:   { label:"tnpdcl-python-one",       tag:"PS-1",  url:"/prod-api",   accent:"#f97316" },
  device: { label:"tnpdcl-kfk-mqtt-red",  tag:"PS-2",  url:"/device-api", accent:"#8b5cf6" },
  micro:  { label:"tnpdcl-docker-one",        tag:"MICRO", url:"/micro-api",  accent:"#10b981" },
  ps3:    { label:"tnpdcl-python-two",     tag:"PS-3",  url:"/ps3-api",    accent:"#e11d48" },
  ep:     { label:"tnpdcl-con-solar-emp",  tag:"EP",    url:"/ep-api",     accent:"#f59e0b" },
  reproc:   { label:"tnpdcl-events-agg",   tag:"REPROC",  url:"/reproc-api",   accent:"#a78bfa" },
  dataproc:  { label:"tnpdcl-dataproc-bn360",   tag:"DATAPROC", url:"/dataproc-api",  accent:"#06b6d4" },
  devdocker:    { label:"sit-docker",             tag:"SIT-DOCK",    url:"/devdocker-api",    accent:"#10b981" },
  tnpdcldock2:  { label:"tnpdcl-docker-two",    tag:"DOCK2",       url:"/tnpdcl-docker2-api", accent:"#ec4899" },
  fsascript:  { label:"BL-PROD-FSA-Script",   tag:"FSA-SCRIPT",  url:"/fsa-script-api",  accent:"#f59e0b" },
  fsadocker1: { label:"BL-PROD-FSA-Docker-1", tag:"FSA-DOCK1",  url:"/fsa-docker1-api", accent:"#06b6d4" },
  iccceroded: { label:"ICCC-Erode-Docker",  tag:"ICCC-E-DOCK", url:"/iccc-erode-docker-api", accent:"#f43f5e" },
  iccceromysql:{ label:"ICCC-Erode-mysql",  tag:"ICCC-E-SQL",  url:"/iccc-erode-mysql-api", accent:"#fb7185" },
  iccctrid:   { label:"ICCC-Trichy-Docker", tag:"ICCC-T-DOCK", url:"/iccc-trichy-docker-api", accent:"#f59e0b" },
  iccctrimysql:{ label:"ICCC-Trichy-mysql", tag:"ICCC-T-SQL",  url:"/iccc-trichy-mysql-api", accent:"#fbbf24" },
  ihodoo:    { label:"Odoo / Websites",    tag:"ODOO",    url:"/inhouse-odoo-api",    accent:"#8b5cf6" },
  ihsim1:    { label:"Simulation Script 1",tag:"SIM-1",   url:"/inhouse-sim1-api",    accent:"#a78bfa" },
  ihsim2:    { label:"Simulation Script 2",tag:"SIM-2",   url:"/inhouse-sim2-api",    accent:"#c4b5fd" },
  ihjenkins: { label:"Bluenett Jenkins",   tag:"JENKINS", url:"/inhouse-jenkins-api", accent:"#d946ef" },
  ihnexus:   { label:"Nexus Server",       tag:"NEXUS",   url:"/inhouse-nexus-api",   accent:"#ec4899" },
  ihvpn:     { label:"OpenVPN",            tag:"VPN",     url:"/inhouse-vpn-api",     accent:"#f472b6" },
  ihges:     { label:"BHL GES (bn-intapp)",tag:"BHL-GES", url:"/inhouse-ges-api",     accent:"#fb7185" },
  fsaevents:  { label:"BL-PROD-FSA-Events",   tag:"FSA-EVENTS", url:"/fsa-events-api",  accent:"#8b5cf6" },
  fsarabbitmq: { label:"BL-PROD-RabbitMQ",  tag:"FSA-MQ",    url:"/fsa-rabbitmq-api", accent:"#f97316" },
  fsakafkazk: { label:"BL-PROD-Kafka-ZK",   tag:"FSA-KZK",   url:"/fsa-kafkazk-api", accent:"#22c55e" },
  fsaconfig: { label:"BL-PROD-Config",     tag:"FSA-CFG",   url:"/fsa-config-api", accent:"#eab308" },
  fsagps: { label:"BL-GPS-Prod",          tag:"FSA-GPS",   url:"/fsa-gps-api", accent:"#ec4899" },
  kafka:  { label:"📨 Kafka",        tag:"KAFKA", url:"",                                   accent:"#f59e0b" },
  redis:  { label:"🔴 Redis",         tag:"REDIS", url:"",                                   accent:"#ef4444" },
  mqtt:   { label:"📡 MQTT",           tag:"MQTT",  url:"",                                   accent:"#8b5cf6" },
  docker: { label:"🐳 Docker",          tag:"DOCK",  url:"",                                   accent:"#06b6d4" },
  onedash:{ label:"📊 OneDash",      tag:"DASH",  url:"",                                   accent:"#6366f1" },
  ai:      { label:"🤖 AI Assistant",  tag:"AI",    url:"",                                   accent:"#6366f1" },
  assets:  { label:"💻 Bluenett Assets", tag:"ASSET", url:"",                              accent:"#10b981" },
  deploy:  { label:"🚀 Docker Deploy", tag:"DEPLOY", url:"",                             accent:"#0ea5e9" },
  fsaonedash:{ label:"📊 FSA OneDash", tag:"FSA-DASH", url:"",                              accent:"#14b8a6" },
  history:{ label:"📈 History",       tag:"HIST",  url:"",                                   accent:"#a78bfa" },
  users:  { label:"👥 Users",          tag:"MGMT",  url:"",                                   accent:"#f472b6" },
  errors: { label:"🔴 Error Console",  tag:"ERRORS",url:"",                                   accent:"#ef4444" },
};

const STATUS = {
  running:     { color:"#10b981", label:"RUNNING"   },
  active:      { color:"#10b981", label:"RUNNING"   },
  inactive:    { color:"#64748b", label:"STOPPED"   },
  stopped:     { color:"#64748b", label:"STOPPED"   },
  failed:      { color:"#ef4444", label:"FAILED"    },
  "not-found": { color:"#475569", label:"NOT FOUND" },
};
const getST = s => STATUS[s] || { color:"#94a3b8", label:"UNKNOWN" };

// ── DOT ─────────────────────────────────────────────────
function Dot({ color, pulse }) {
  return (
    <span style={{position:"relative",display:"inline-flex",alignItems:"center",justifyContent:"center",width:10,height:10}}>
      {pulse && <span style={{position:"absolute",inset:0,borderRadius:"50%",background:color,
        opacity:.25,animation:"ripple 2s ease-out infinite"}}/>}
      <span style={{width:8,height:8,borderRadius:"50%",background:color,display:"block"}}/>
    </span>
  );
}

// ── CPU BAR ─────────────────────────────────────────────
function CpuBar({ value, theme }) {
  const num = parseFloat(value);
  if (isNaN(num)) return <span style={{fontSize:15,color:theme.textMuted,fontFamily:"'Inter',sans-serif"}}>N/A</span>;
  const color = num > 80 ? "#ef4444" : num > 50 ? "#f59e0b" : "#10b981";
  return (
    <div style={{display:"flex",alignItems:"center",gap:7}}>
      <div style={{width:52,height:4,background:theme.border,borderRadius:2,overflow:"hidden"}}>
        <div style={{width:`${Math.min(num,100)}%`,height:"100%",background:color,
          borderRadius:2,transition:"width .4s ease"}}/>
      </div>
      <span style={{fontSize:15,color,fontFamily:"'Inter',monospace",fontWeight:600,minWidth:38}}>{value}</span>
    </div>
  );
}

// ── SERVICE ROW ─────────────────────────────────────────
function GlobalSearch({ token, theme, onNavigate }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [cache, setCache] = useState(null);
  useEffect(() => {
    if (!open) return;
    let alive = true;
    const H = { "X-Auth-Token": token };
    // reuse cache if fresh (<20s), else fetch all servers
    if (cache && Date.now() - cache.ts < 20000) return;
    setLoading(true);
    const timer = setTimeout(() => {
    if (!alive) return;
    const targets = Object.entries(SERVERS).filter(([k,s]) => s.url && !s.isDB && !["home"].includes(k));
    let collected = [];
    let done = 0;
    targets.forEach(([key, s]) => {
      fetch(`${s.url}/services`, { headers: H, signal: AbortSignal.timeout(6000) })
        .then(r => r.ok ? r.json() : null)
        .then(d => {
          const svcs = (d && d.services) ? d.services : [];
          const mapped = svcs.map(svc => ({ ...svc, _server: key, _label: s.label, _tag: s.tag, _accent: s.accent }));
          if (!alive) return;
          collected = collected.concat(mapped);
          setCache({ data: collected, ts: Date.now() });
        })
        .catch(() => {})
        .finally(() => {
          done++;
          if (done >= targets.length && alive) setLoading(false);
        });
    });
    }, 150);
    return () => { alive = false; clearTimeout(timer); };
  }, [open, token]);

  // instant filter from cache whenever q or cache changes
  const filtered = (() => {
    if (!q || !cache) return [];
    const ql = q.toLowerCase();
    return cache.data.filter(svc =>
      (svc.name||"").toLowerCase().includes(ql) ||
      (svc.description||"").toLowerCase().includes(ql)
    ).slice(0, 40);
  })();

  // open on Ctrl+K / Cmd+K, close on Esc
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen(true); }
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <button onClick={() => setOpen(true)}
        style={{display:"flex", alignItems:"center", gap:8, background:theme.inputBg,
          border:`1px solid ${theme.border}`, color:theme.textMuted, borderRadius:8,
          padding:"7px 14px", cursor:"pointer", fontFamily:"'Inter',sans-serif", fontSize:13,
          minWidth:200, transition:"border .2s"}}
        onMouseEnter={e=>e.currentTarget.style.borderColor=theme.borderAccent||"#3b82f6"}
        onMouseLeave={e=>e.currentTarget.style.borderColor=theme.border}>
        <span>🔍</span>
        <span style={{flex:1, textAlign:"left"}}>Search all servers...</span>
        <span style={{fontSize:11, background:theme.bg, border:`1px solid ${theme.border}`,
          borderRadius:4, padding:"1px 6px", color:theme.textFaint}}>⌘K</span>
      </button>

      {open && (
        <div className="bn360-search-modal" onClick={() => { setOpen(false); }}
          style={{position:"fixed", inset:0, zIndex:9999, background:"rgba(0,0,0,0.6)",
            backdropFilter:"blur(3px)", display:"flex", alignItems:"flex-start",
            justifyContent:"center", paddingTop:"12vh"}}>
          <div onClick={e => e.stopPropagation()}
            style={{width:"90%", maxWidth:640, background:theme.bgCard,
              border:`1px solid ${theme.border}`, borderRadius:14,
              boxShadow:"0 20px 60px rgba(0,0,0,0.5)", overflow:"hidden"}}>
            <div style={{display:"flex", alignItems:"center", gap:10, padding:"16px 20px",
              borderBottom:`1px solid ${theme.border}`}}>
              <span style={{fontSize:18}}>🔍</span>
              <input autoFocus value={q}
                onChange={e => setQ(e.target.value)}
                placeholder="Search services across all servers..."
                style={{flex:1, background:"transparent", border:"none", outline:"none",
                  color:theme.text, fontFamily:"'Inter',sans-serif", fontSize:17}}/>
              <span style={{fontSize:11, background:theme.bg, border:`1px solid ${theme.border}`,
                borderRadius:4, padding:"2px 7px", color:theme.textFaint}}>ESC</span>
            </div>
            <div style={{maxHeight:"56vh", overflowY:"auto"}}>
              {loading && <div style={{padding:20, color:theme.textMuted, fontSize:14, textAlign:"center"}}>Searching all servers...</div>}
              {!loading && q && filtered.length === 0 && <div style={{padding:20, color:theme.textMuted, fontSize:14, textAlign:"center"}}>No services found</div>}
              {!q && <div style={{padding:20, color:theme.textFaint, fontSize:13, textAlign:"center"}}>Type to search across all servers</div>}
              {filtered.map((svc, i) => {
                const running = svc.status === "running" || svc.status === "active";
                return (
                  <div key={i} onClick={() => { onNavigate(svc._server, svc.name); setOpen(false); setQ(""); }}
                    style={{padding:"13px 20px", cursor:"pointer", borderBottom:`1px solid ${theme.border}`,
                      display:"flex", alignItems:"center", gap:12}}
                    onMouseEnter={e=>e.currentTarget.style.background=theme.bgHover}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    <span style={{width:8, height:8, borderRadius:"50%",
                      background: running ? "#10b981" : "#ef4444", flexShrink:0}}/>
                    <div style={{minWidth:0, flex:1}}>
                      <div style={{fontSize:15, color:theme.text, fontWeight:600, whiteSpace:"nowrap",
                        overflow:"hidden", textOverflow:"ellipsis"}}>{svc.name}</div>
                      <div style={{fontSize:12, color:theme.textMuted}}>{svc._label}</div>
                    </div>
                    <span style={{fontSize:11, fontWeight:700, color:svc._accent,
                      background:`${svc._accent}18`, padding:"3px 9px", borderRadius:5, whiteSpace:"nowrap"}}>{svc._tag}</span>
                    <span style={{fontSize:14, color:theme.textMuted, fontFamily:"monospace", minWidth:48, textAlign:"right"}}>
                      {svc.cpu != null ? `${parseFloat(svc.cpu).toFixed(0)}%` : "—"}</span>
                  </div>
                );
              })}
            </div>
            {filtered.length > 0 && (
              <div style={{padding:"8px 20px", borderTop:`1px solid ${theme.border}`,
                fontSize:11, color:theme.textFaint}}>{filtered.length} result{filtered.length!==1?"s":""} · click to open</div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

function Sparkline({ envKey, service, token, color }) {
  const [pts, setPts] = useState(null);
  useEffect(() => {
    let alive = true;
    const clean = (service||"").replace(/ \(\d+x\)$/,"");
    const url = window.location.origin + "/metrics-api/history/services?server=" + encodeURIComponent(envKey) + "&service=" + encodeURIComponent(clean) + "&hours=6";
    fetch(url, { headers:{ "X-Auth-Token": token }, signal: AbortSignal.timeout(8000) })
      .then(function(r){ return r.ok ? r.json() : []; })
      .then(function(rows){ if (alive && Array.isArray(rows)) setPts(rows.map(function(x){return x.cpu||0;}).slice(-24)); })
      .catch(function(){ if (alive) setPts([]); });
    return function(){ alive = false; };
  }, [envKey, service, token]);
  if (!pts || pts.length < 2) return null;
  var max = Math.max.apply(null, pts.concat([1])), w = 110, h = 24, step = w/(pts.length-1);
  var poly = pts.map(function(v,i){ return (i*step).toFixed(1)+","+(h-(v/max)*(h-4)-2).toFixed(1); }).join(" ");
  return <svg width={w} height={h} style={{display:"block",marginTop:4}}><polyline points={poly} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" opacity="0.85"/></svg>;
}

function ServiceRow({ svc, selected, onClick, accent, theme, envKey, token }) {
  const st    = getST(svc.status);
  const alive = svc.status === "running" || svc.status === "active";
  const [hov, setHov] = useState(false);
  const isHot = (parseFloat(svc.cpu) || 0) > 85;
  return (
    <div onClick={() => onClick(svc)}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        display:"grid",
        gridTemplateColumns:"12px minmax(160px,1fr) 100px 90px 110px 100px 100px 140px",
        alignItems:"center", gap:12, padding:"10px 20px",
        background: selected ? theme.bgSelected : hov ? theme.bgHover : "transparent",
        borderLeft: selected ? `3px solid ${accent}` : "3px solid transparent",
        borderBottom: `1px solid ${theme.border}`,
        cursor:"pointer", transition:"all .15s",
        position:"relative",
        boxShadow: isHot ? "0 0 20px 2px rgba(239,68,68,0.55), inset 0 -12px 22px -14px rgba(245,120,20,0.5)" : "none",
      }}>
      <style>{`
        @keyframes flameFlicker{0%,100%{transform:translateX(-50%) scaleY(1) scaleX(1);opacity:.92}25%{transform:translateX(-50%) scaleY(1.15) scaleX(.95) translateY(-2px);opacity:1}50%{transform:translateX(-50%) scaleY(.92) scaleX(1.05) translateY(1px);opacity:.85}75%{transform:translateX(-50%) scaleY(1.08) scaleX(.98);opacity:.95}}
        @keyframes flameHue{0%,100%{filter:hue-rotate(0deg) brightness(1)}50%{filter:hue-rotate(-12deg) brightness(1.2)}}
        .bn-fire{position:absolute;right:70px;top:8px;width:30px;height:40px;pointer-events:none;z-index:5}
        .bn-fire .flame{position:absolute;bottom:0;left:50%;width:24px;height:34px;background:radial-gradient(ellipse at 50% 100%,#fff6a0 0%,#ffd24d 25%,#ff8c1a 50%,#ff3d00 75%,#d81a00 100%);clip-path:polygon(50% 0%,68% 30%,80% 55%,72% 80%,88% 72%,78% 95%,50% 100%,22% 95%,12% 72%,28% 80%,20% 55%,32% 30%);animation:flameFlicker .6s ease-in-out infinite,flameHue 1.2s ease-in-out infinite;transform-origin:center bottom;box-shadow:0 0 14px 3px rgba(255,90,0,.5)}
        .bn-fire .flame-inner{position:absolute;bottom:2px;left:50%;transform:translateX(-50%);width:11px;height:19px;background:radial-gradient(ellipse at 50% 100%,#fff 0%,#fff2a0 40%,#ffd24d 100%);clip-path:polygon(50% 0%,70% 40%,65% 75%,50% 100%,35% 75%,30% 40%);animation:flameFlicker .45s ease-in-out infinite reverse;transform-origin:center bottom}
      `}</style>
      {isHot && (
        <div className="bn-fire"><div className="flame"></div><div className="flame-inner"></div></div>
      )}
      {/* dot */}
      <Dot color={st.color} pulse={alive}/>

      {/* name + desc */}
      <div style={{minWidth:0}}>
        <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:2}}>
          <span style={{fontFamily:"'Inter',sans-serif",fontSize:15,color:theme.text,
            fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",
            whiteSpace:"nowrap",fontSize:16}}>{svc.name}</span>
          <span style={{fontSize:15,color:st.color,background:`${st.color}18`,
            padding:"2px 8px",borderRadius:4,letterSpacing:".06em",
            border:`1px solid ${st.color}30`,flexShrink:0,fontWeight:700,fontSize:16,
            fontFamily:"'Inter',sans-serif"}}>{st.label}</span>
        </div>
        <span style={{fontSize:15,color:theme.textMuted,overflow:"hidden",
          textOverflow:"ellipsis",whiteSpace:"nowrap",display:"block",fontSize:16,
          fontFamily:"'Inter',sans-serif"}}>{svc.description}</span>
        {(svc.script_path||svc.path)&&(
          <span style={{fontSize:15,color:"#64748b",overflow:"hidden",
            textOverflow:"ellipsis",whiteSpace:"nowrap",display:"block",
            fontFamily:"'Fira Code',monospace",marginTop:2}}>
            📄 {svc.script_path||svc.path}
          </span>
        )}
        {svc.log_files&&svc.log_files.some(lf=>lf.bytes>=2*1073741824)&&(
          <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:3}}>
            {svc.log_files.filter(lf=>lf.bytes>=2*1073741824).map((lf,i)=>(
              <span key={i} style={{fontSize:15,fontWeight:700,padding:"1px 7px",
                borderRadius:4,background:"rgba(239,68,68,0.12)",
                border:"1px solid rgba(239,68,68,0.3)",color:"#ef4444",
                fontFamily:"'Inter',sans-serif"}}>
                ⚠️ {lf.file||lf.path.split("/").pop()} ({lf.size})
              </span>
            ))}
          </div>
        )}
      </div>

      {/* owner */}
      <div style={{minWidth:0}}>
        <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".08em",
          fontFamily:"'Inter',sans-serif",fontWeight:600,marginBottom:2,fontSize:16}}>OWNER</div>
        <div style={{fontSize:15,color:theme.textSub,fontFamily:"'Inter',sans-serif",
          fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",fontSize:16,
          whiteSpace:"nowrap"}}>—</div>
      </div>

      {/* cpu */}
      <div>
        <div style={{fontSize:16,color:theme.textMuted,letterSpacing:".06em",
          fontFamily:"'Inter',sans-serif",fontWeight:600,marginBottom:3}}>CPU</div>
        {alive ? <CpuBar value={svc.cpu} theme={theme}/> :
          <span style={{fontSize:15,color:theme.textFaint}}>—</span>}
      
        {alive && envKey && token ? <Sparkline envKey={envKey} service={svc.name} token={token} color={parseFloat(svc.cpu)>80?"#ef4444":parseFloat(svc.cpu)>50?"#f59e0b":"#10b981"}/> : null}
      </div>

      {/* memory */}
      <div>
        <div style={{fontSize:16,color:theme.textMuted,letterSpacing:".06em",
          fontFamily:"'Inter',sans-serif",fontWeight:600,marginBottom:2}}>MEMORY</div>
        <span style={{fontSize:15,color:alive?theme.textSub:theme.textFaint,
          fontFamily:"'Inter',monospace",fontWeight:600,fontSize:15}}>
          {alive ? svc.memory : "—"}
        </span>
      </div>

      {/* uptime */}
      <div>
        <div style={{fontSize:16,color:theme.textMuted,letterSpacing:".06em",
          fontFamily:"'Inter',sans-serif",fontWeight:600,marginBottom:2}}>UPTIME</div>
        <span style={{fontSize:15,color:alive?theme.textSub:theme.textFaint,
          fontFamily:"'Inter',monospace",fontWeight:600,fontSize:15}}>
          {alive ? svc.uptime : "—"}
        </span>
      </div>

      {/* mem limit */}
      <div>
        <div style={{fontSize:16,color:theme.textMuted,letterSpacing:".06em",
          fontFamily:"'Inter',sans-serif",fontWeight:600,marginBottom:2}}>MEM LIMIT</div>
        <span style={{fontSize:15,
          color:svc.mem_limit&&svc.mem_limit!=="unlimited"?"#f97316":"#64748b",
          fontFamily:"'Inter',monospace",fontWeight:600,fontSize:15}}>
          {svc.mem_limit||"—"}
        </span>
      </div>

      {/* ports */}
      <div style={{minWidth:0}}>
        <div style={{fontSize:16,color:theme.textMuted,letterSpacing:".06em",
          fontFamily:"'Inter',sans-serif",fontWeight:600,marginBottom:2}}>PORTS</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:3}}>
          {(() => { const hp = cleanPorts(svc.ports); return hp.length > 0 ? (<>
            {hp.slice(0,6).map((p,i)=>(
            <span key={i} style={{
              fontSize:16,color:"#06b6d4",fontFamily:"'Fira Code',monospace",fontWeight:700,
              background:"rgba(6,182,212,0.1)",border:"1px solid rgba(6,182,212,0.3)",
              padding:"3px 10px",borderRadius:5,whiteSpace:"nowrap",
            }}>{p}</span>
            ))}
            {hp.length > 6 && <span style={{fontSize:15,color:theme.textMuted,padding:"3px 6px"}}>+{hp.length-6} more</span>}
          </>) : <span style={{fontSize:15,color:theme.textFaint}}>—</span>; })()}
        </div>
      </div>
    </div>
  );
}

// ── DETAIL PANE ──────────────────────────────────────────
function DetailPane({ svc, logs, onClose, onRestart, onStart, onStop, onTruncate, onLoadMore, accent, theme }) {
  const [showFullLog, setShowFullLog] = useState(false);
  if (!svc) return null;
  const st = getST(svc.status);
  return (
    <div style={{display:"flex",flexDirection:"column",gap:14,height:"100%",
      background:theme.bgCard,borderLeft:`1px solid ${theme.border}`,
      padding:20,overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
        <div>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
            <Dot color={st.color} pulse={svc.status==="running"||svc.status==="active"}/>
            <span style={{fontFamily:"'Inter',sans-serif",fontSize:15,color:theme.text,fontWeight:700}}>{svc.name}</span>
          </div>
          <div style={{fontSize:15,color:theme.textMuted,fontFamily:"'Inter',sans-serif"}}>{svc.description}</div>
        </div>
        <button onClick={onClose} style={{background:theme.inputBg,
          border:`1px solid ${theme.border}`,color:theme.textMuted,
          borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:15,
          fontFamily:"'Inter',sans-serif"}}>✕ close</button>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
        {[["STATUS",st.label,st.color],["UPTIME",svc.uptime,theme.text],
          ["PID",svc.pid||"—",theme.text],
          ["STARTED",svc.started_at?.slice(0,30)||"N/A",theme.textSub]].map(([l,v,c])=>(
          <div key={l} style={{background:theme.metricsBg,borderRadius:8,
            padding:"10px 12px",border:`1px solid ${theme.border}`}}>
            <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",
              marginBottom:4,fontFamily:"'Inter',sans-serif",fontWeight:600}}>{l}</div>
            <div style={{fontSize:16,color:c,fontFamily:"'Inter',monospace",
              fontWeight:600,wordBreak:"break-all"}}>{v}</div>
          </div>
        ))}
        {/* CPU */}
        <div style={{background:theme.metricsBg,borderRadius:8,
          padding:"10px 12px",border:`1px solid ${theme.border}`}}>
          <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",
            marginBottom:6,fontFamily:"'Inter',sans-serif",fontWeight:600}}>CPU</div>
          <CpuBar value={svc.cpu||"N/A"} theme={theme}/>
        </div>
      </div>
      {/* Script path info */}
      {(svc.script_path||svc.work_dir||svc.path)&&(
        <div style={{marginTop:8,background:theme.metricsBg,borderRadius:8,
          padding:"10px 14px",border:`1px solid ${theme.border}`}}>
          <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",
            marginBottom:8,fontFamily:"'Inter',sans-serif",fontWeight:600}}>📁 SERVICE PATH</div>
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            {(svc.script_file||svc.path)&&(
              <div style={{display:"flex",gap:8,alignItems:"baseline"}}>
                <span style={{fontSize:15,color:theme.textMuted,fontFamily:"'Inter',sans-serif",
                  fontWeight:600,minWidth:50}}>FILE</span>
                <span style={{fontSize:15,color:"#10b981",fontFamily:"'Fira Code',monospace",
                  fontWeight:600}}>{svc.script_file||svc.path}</span>
              </div>
            )}
            {svc.work_dir&&(
              <div style={{display:"flex",gap:8,alignItems:"baseline"}}>
                <span style={{fontSize:15,color:theme.textMuted,fontFamily:"'Inter',sans-serif",
                  fontWeight:600,minWidth:50}}>DIR</span>
                <span style={{fontSize:15,color:"#06b6d4",fontFamily:"'Fira Code',monospace",
                  wordBreak:"break-all"}}>{svc.work_dir}</span>
              </div>
            )}
            {svc.script_path&&svc.script_path!==svc.work_dir+"/"+svc.script_file&&(
              <div style={{display:"flex",gap:8,alignItems:"baseline"}}>
                <span style={{fontSize:15,color:theme.textMuted,fontFamily:"'Inter',sans-serif",
                  fontWeight:600,minWidth:50}}>PATH</span>
                <span style={{fontSize:16,color:"#94a3b8",fontFamily:"'Fira Code',monospace",
                  wordBreak:"break-all"}}>{svc.script_path}</span>
              </div>
            )}
            {svc.unit_file&&(
              <div style={{display:"flex",gap:8,alignItems:"baseline"}}>
                <span style={{fontSize:15,color:theme.textMuted,fontFamily:"'Inter',sans-serif",
                  fontWeight:600,minWidth:50}}>UNIT</span>
                <span style={{fontSize:16,color:"#64748b",fontFamily:"'Fira Code',monospace",
                  wordBreak:"break-all"}}>{svc.unit_file}</span>
              </div>
            )}
          </div>
          {svc.log_files&&svc.log_files.length>0&&(
            <div style={{marginTop:10}}>
              <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",
                fontFamily:"'Inter',sans-serif",fontWeight:700,marginBottom:6}}>LOG FILES</div>
              <div style={{display:"flex",flexDirection:"column",gap:4}}>
                {svc.log_files.map((lf,i)=>(
                  <div key={i} style={{display:"flex",justifyContent:"space-between",
                    alignItems:"center",background:theme.bg,borderRadius:6,
                    padding:"6px 10px",border:`1px solid ${theme.border}`}}>
                    <span style={{fontSize:16,color:"#94a3b8",fontFamily:"'Fira Code',monospace",
                      overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:1}}>
                      📄 {lf.file||lf.path.split("/").pop()}
                    </span>
                    <span style={{fontSize:16,fontWeight:700,fontFamily:"'Inter',monospace",
                      color:lf.bytes>100*1048576?"#ef4444":lf.bytes>10*1048576?"#f59e0b":"#10b981",
                      marginLeft:12,flexShrink:0}}>
                      {lf.size}
                    </span>
                    <button onClick={()=>onTruncate(svc.name, lf.path, lf.file||lf.path.split("/").pop())}
                      style={{marginLeft:8,fontSize:15,padding:"2px 8px",borderRadius:4,
                        cursor:"pointer",fontFamily:"'Inter',sans-serif",fontWeight:600,
                        background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",
                        color:"#ef4444",flexShrink:0}}>
                      🗑 Truncate
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
        {/* Memory usage + limit */}
        <div style={{background:theme.metricsBg,borderRadius:8,
          padding:"10px 12px",border:`1px solid ${theme.border}`,gridColumn:"span 2"}}>
          <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",
            marginBottom:6,fontFamily:"'Inter',sans-serif",fontWeight:600}}>MEMORY</div>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:5}}>
            <span style={{fontSize:16,color:theme.text,fontFamily:"'Inter',monospace",fontWeight:700}}>
              {svc.memory||"N/A"}
            </span>
            <span style={{fontSize:15,color:theme.textMuted,fontFamily:"'Inter',sans-serif"}}>
              limit: <span style={{color:"#f97316",fontWeight:600}}>{svc.mem_limit||"N/A"}</span>
            </span>
            {svc.mem_pct && (
              <span style={{fontSize:15,color:
                parseFloat(svc.mem_pct)>85?"#ef4444":
                parseFloat(svc.mem_pct)>70?"#f59e0b":"#10b981",
                fontWeight:700,fontFamily:"'Inter',monospace"}}>
                {svc.mem_pct}
              </span>
            )}
          </div>
          {svc.mem_pct && (
            <div style={{height:5,background:theme.border,borderRadius:3,overflow:"hidden"}}>
              <div style={{
                width:`${Math.min(parseFloat(svc.mem_pct),100)}%`,height:"100%",borderRadius:3,
                background: parseFloat(svc.mem_pct)>85?"#ef4444":
                            parseFloat(svc.mem_pct)>70?"#f59e0b":"#8b5cf6",
                transition:"width .5s ease",
              }}/>
            </div>
          )}
        </div>
        {/* Disk IO */}
        {svc.disk_read && (
          <div style={{background:theme.metricsBg,borderRadius:8,
            padding:"10px 12px",border:`1px solid ${theme.border}`}}>
            <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",
              marginBottom:6,fontFamily:"'Inter',sans-serif",fontWeight:600}}>DISK I/O</div>
            <div style={{display:"flex",gap:12}}>
              <div>
                <div style={{fontSize:15,color:"#64748b",fontFamily:"'Inter',sans-serif",marginBottom:2}}>READ</div>
                <div style={{fontSize:15,fontWeight:700,color:"#06b6d4",fontFamily:"'Inter',monospace"}}>{svc.disk_read}</div>
              </div>
              <div>
                <div style={{fontSize:15,color:"#64748b",fontFamily:"'Inter',sans-serif",marginBottom:2}}>WRITE</div>
                <div style={{fontSize:15,fontWeight:700,color:"#f59e0b",fontFamily:"'Inter',monospace"}}>{svc.disk_write}</div>
              </div>
            </div>
            {svc.log_mb != null && (
              <div style={{marginTop:10,paddingTop:10,borderTop:`1px solid ${theme.border}`}}>
                <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",marginBottom:4,fontFamily:"'Inter',sans-serif",fontWeight:600}}>LOG SIZE</div>
                <div style={{fontSize:16,fontWeight:700,color:(svc.log_mb>=1024?"#ef4444":svc.log_mb>=500?"#f59e0b":"#10b981"),fontFamily:"'Inter',monospace"}}>
                  {svc.log_mb>=1024?`${(svc.log_mb/1024).toFixed(1)} GB`:`${Math.round(svc.log_mb)} MB`}</div>
              </div>
            )}
          </div>
        )}
        {/* Ports */}
        {svc.ports && svc.ports.length > 0 && (
          <div style={{background:theme.metricsBg,borderRadius:8,
            padding:"10px 12px",border:`1px solid ${theme.border}`,gridColumn:"span 3"}}>
            <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",
              marginBottom:8,fontFamily:"'Inter',sans-serif",fontWeight:600}}>PORTS</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {cleanPorts(svc.ports).slice(0,10).map((p,i)=>(
                <span key={i} style={{
                  fontSize:15,color:"#06b6d4",fontFamily:"'Fira Code',monospace",fontWeight:600,
                  background:"rgba(6,182,212,0.08)",border:"1px solid rgba(6,182,212,0.25)",
                  padding:"3px 10px",borderRadius:5,
                }}>{p}</span>
              ))}
              {cleanPorts(svc.ports).length > 10 && <span style={{fontSize:14,color:theme.textMuted,padding:"3px 8px"}}>+{cleanPorts(svc.ports).length-10} more</span>}
            </div>
          </div>
        )}
      </div>

      <button onClick={() => onRestart(svc.name.replace(/ \(\d+x\)$/, ""))} style={{
        background:`${accent}15`,border:`1px solid ${accent}40`,color:accent,
        borderRadius:8,padding:"9px",cursor:"pointer",fontSize:16,
        fontFamily:"'Inter',sans-serif",fontWeight:600,letterSpacing:".04em",
        transition:"all .2s"}}>
        ↺ Restart Service
      </button>

      <div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
          <div style={{fontSize:16,color:theme.textMuted,letterSpacing:".1em",
            fontFamily:"'Inter',sans-serif",fontWeight:700}}>JOURNAL LOGS</div>
          <button onClick={()=>setShowFullLog(true)} style={{fontSize:12,padding:"3px 10px",borderRadius:5,cursor:"pointer",background:"rgba(99,102,241,0.1)",border:"1px solid rgba(99,102,241,0.3)",color:"#6366f1",fontFamily:"'Inter',sans-serif",fontWeight:600}}>Full Screen</button>
        </div>
        <div style={{background:theme.logBg,borderRadius:8,padding:14,
          border:`1px solid ${theme.border}`,maxHeight:280,overflowY:"auto",
          fontFamily:"'Fira Code',monospace",fontSize:10.5,lineHeight:1.9}}>
          {(logs||["No logs available"]).map((l,i)=>(
            <div key={i} style={{color:
              /error|fail|crit/i.test(l)?"#ef4444":
              /warn/i.test(l)?"#f59e0b":
              /start|running|active/i.test(l)?"#10b981":theme.textMuted}}>{l||" "}</div>
          ))}
        </div>
      </div>
      {showFullLog&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.92)",zIndex:99999,display:"flex",flexDirection:"column"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 20px",borderBottom:`1px solid ${theme.border}`,background:theme.bgCard}}>
            <div style={{fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:700,color:theme.text}}>{svc.name} - Full Log Viewer<span style={{fontSize:12,color:theme.textMuted,marginLeft:12}}>{logs?.length||0} lines loaded</span></div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>onLoadMore&&onLoadMore()} style={{fontSize:12,padding:"5px 12px",borderRadius:5,cursor:"pointer",background:"rgba(16,185,129,0.1)",border:"1px solid rgba(16,185,129,0.3)",color:"#10b981",fontFamily:"'Inter',sans-serif",fontWeight:600}}>Load More (1000 lines)</button>
              <button onClick={()=>setShowFullLog(false)} style={{fontSize:12,padding:"5px 12px",borderRadius:5,cursor:"pointer",background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",color:"#ef4444",fontFamily:"'Inter',sans-serif",fontWeight:600}}>Close</button>
            </div>
          </div>
          <div style={{flex:1,overflowY:"auto",padding:16,fontFamily:"'Fira Code',monospace",fontSize:11,lineHeight:1.8}}>
            {(logs||["No logs available"]).map((l,i)=>(<div key={i} style={{color:/error|fail|crit/i.test(l)?"#ef4444":/warn/i.test(l)?"#f59e0b":/start|running|active/i.test(l)?"#10b981":"#94a3b8"}}>{l||" "}</div>))}
          </div>
        </div>
      )}
    </div>
  );
}

function ErrorConsole({ env, token, theme, role }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUp, setLastUp] = useState(null);
  // env -> server keys (mirror of groups, real servers only)
  const ENV_SERVERS = {
    inhouse: ["ihodoo","ihsim1","ihsim2","ihjenkins","ihnexus","ihvpn","ihges"],
    "iccc-erode": ["iccceroded","iccceromysql"],
    "iccc-trichy": ["iccctrid","iccctrimysql"],
    fsa: ["fsascript","fsadocker1","fsaevents","fsarabbitmq","fsakafkazk","fsaconfig","fsagps","fsadb"],
    tnpdcl: ["dev","devdocker","prod","device","micro","ps3","ep","reproc","dataproc","tnpdcldock2","db"],
  };
  const keys = ENV_SERVERS[env||"tnpdcl"] || ENV_SERVERS.tnpdcl;
  const load = useCallback(async () => {
    const all = [];
    await Promise.all(keys.map(async (k) => {
      const cfg = SERVERS[k];
      if (!cfg || !cfg.url) return;
      try {
        const r = await fetch(`${cfg.url}/errors`, { signal: AbortSignal.timeout(12000), headers:{ "X-Auth-Token": token } });
        if (!r.ok) return;
        const d = await r.json();
        (d.errors||[]).forEach(e => all.push({ ...e, server: cfg.label, hostname: d.hostname||"", ip: d.ip||"", serverKey: k, url: cfg.url }));
      } catch {}
    }));
    const rank = { OOM:0, FATAL:1, EXCEPTION:2, ERROR:3 };
    all.sort((a,b)=>(rank[a.severity]??9)-(rank[b.severity]??9) || (b.count||0)-(a.count||0));
    setRows(all); setLoading(false); setLastUp(new Date());
  }, [env, token]);
  useEffect(()=>{ load(); const id=setInterval(load,30000); return ()=>clearInterval(id); }, [load]);
  const sevColor = (s)=> s==="OOM"?"#ef4444": s==="FATAL"?"#dc2626": s==="EXCEPTION"?"#f59e0b":"#eab308";
  const restart = async (url, name) => {
    if (role==="readonly") return;
    try { await fetch(`${url}/services/${encodeURIComponent(name.replace(/ \(\d+x\)$/,""))}/restart`, { method:"POST", headers:{ "X-Auth-Token": token } }); setTimeout(load,2000); } catch {}
  };
  const th={padding:"9px 12px",fontSize:11,fontWeight:700,color:theme.textMuted,textAlign:"left",borderBottom:`1px solid ${theme.border}`,letterSpacing:".05em",whiteSpace:"nowrap"};
  const td={padding:"8px 12px",fontSize:12,borderBottom:`1px solid ${theme.border}`,color:theme.text,verticalAlign:"top"};
  return (
    <div style={{padding:20,overflowY:"auto",height:"100%"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
        <div>
          <div style={{fontSize:20,fontWeight:700,color:theme.text,fontFamily:"'Inter',sans-serif"}}>🔴 Error Console</div>
          <div style={{fontSize:13,color:theme.textMuted}}>Log errors across {keys.length} servers in this environment</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          {lastUp && <span style={{fontSize:11,color:theme.textMuted,fontFamily:"monospace"}}>updated {lastUp.toLocaleTimeString()}</span>}
          <button onClick={load} style={{fontSize:12,padding:"6px 14px",borderRadius:6,cursor:"pointer",background:"rgba(59,130,246,0.1)",border:"1px solid rgba(59,130,246,0.3)",color:"#3b82f6",fontWeight:600}}>↻ Refresh</button>
        </div>
      </div>
      {loading ? (
        <div style={{padding:40,textAlign:"center",color:theme.textMuted}}>Scanning logs…</div>
      ) : rows.length===0 ? (
        <div style={{padding:50,textAlign:"center"}}>
          <div style={{fontSize:42,marginBottom:10}}>✓</div>
          <div style={{fontSize:16,color:"#10b981",fontWeight:600}}>All clear — no errors detected</div>
          <div style={{fontSize:13,color:theme.textMuted,marginTop:6}}>Logs scanned across {keys.length} servers</div>
        </div>
      ) : (
        <div style={{background:theme.bgCard,borderRadius:10,border:`1px solid ${theme.border}`,overflow:"hidden"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr>
              <th style={th}>SEVERITY</th><th style={th}>SERVER</th><th style={th}>TIME</th><th style={th}>SERVICE</th>
              <th style={th}>LOG FILE</th><th style={th}>COUNT</th><th style={{...th,width:"40%"}}>LAST ERROR</th>
              {role!=="readonly" && <th style={th}>ACTION</th>}
            </tr></thead>
            <tbody>
              {rows.map((e,i)=>(
                <tr key={i}>
                  <td style={td}><span style={{fontSize:10,fontWeight:700,padding:"3px 9px",borderRadius:5,background:`${sevColor(e.severity)}22`,color:sevColor(e.severity),fontFamily:"monospace"}}>{e.severity}</span></td>
                  <td style={{...td,whiteSpace:"nowrap"}}>
                    <div style={{color:theme.text,fontWeight:600}}>{e.hostname||e.server}</div>
                    <div style={{color:theme.textMuted,fontSize:10.5,fontFamily:"monospace"}}>{e.ip||e.server}</div>
                  </td>
                  <td style={{...td,whiteSpace:"nowrap",fontFamily:"monospace",fontSize:11,color:theme.textMuted}}>{e.time||"—"}</td>
                  <td style={{...td,fontWeight:600,whiteSpace:"nowrap"}}>{e.service}</td>
                  <td style={{...td,fontFamily:"monospace",fontSize:11,color:theme.textMuted,whiteSpace:"nowrap"}}>{e.log_file}</td>
                  <td style={{...td,fontWeight:700,color:sevColor(e.severity)}}>{e.count}</td>
                  <td style={{...td,fontFamily:"'Fira Code',monospace",fontSize:10.5,color:"#f87171",wordBreak:"break-word"}}>{e.last_error}</td>
                  {role!=="readonly" && <td style={td}><button onClick={()=>restart(e.url,e.service)} style={{fontSize:11,padding:"4px 10px",borderRadius:5,cursor:"pointer",background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",color:"#ef4444",fontWeight:600,whiteSpace:"nowrap"}}>↺ Restart</button></td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── ENV PANEL ────────────────────────────────────────────
function EnvPanel({ envKey, selected, setSelected, filter, search, token, theme }) {
  const cfg = SERVERS[envKey];
  const [data,    setData]    = useState(null);
  const [logs,    setLogs]    = useState([]);
  const [offline, setOffline] = useState(false);
  const [lastUp,  setLastUp]  = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const r = await fetch(`${cfg.url}/services`, {
        signal: AbortSignal.timeout(15000),
        headers: { "X-Auth-Token": token },
      });
      const d = await r.json();
      setData(d); setOffline(false);
    } catch { setOffline(true); }
    setLastUp(new Date());
  }, [cfg.url, token]);

  const fetchLogs = useCallback(async (name) => {
    try {
      const r = await fetch(`${cfg.url}/services/${name}`, { headers: { "X-Auth-Token": token } });
      const d = await r.json();
      setLogs(d.logs || []);
      // Update selected service with log_files from detail response
      if (d.log_files) {
        setSelected(prev => prev ? {...prev, log_files: d.log_files} : prev);
      }
    } catch { setLogs(["Cannot reach agent"]); }
  }, [cfg.url, token]);
  const [logLines, setLogLines] = useState(200);
  const handleLoadMore = async () => {
    const newLines = logLines + 1000;
    setLogLines(newLines);
    try {
      const r = await fetch(`${cfg.url}/services/${selected?.name?.replace(/ \(\d+x\)$/, "")}?lines=${newLines}`, { headers:{"X-Auth-Token":token} });
      const d = await r.json();
      if (d.logs) setLogs(d.logs);
    } catch {}
  };

  const handleRestart = async (name) => {
    try { await fetch(`${cfg.url}/services/${name}/restart`, { method:"POST", headers:{"X-Auth-Token":token} }); } catch {}
    setTimeout(fetchData, 2000);
  };
  const handleStart = async (name) => {
    try { await fetch(`${cfg.url}/services/${name}/start`, { method:"POST", headers:{"X-Auth-Token":token} }); } catch {}
    setTimeout(fetchData, 2000);
  };
  const handleStop = async (name) => {
    try { await fetch(`${cfg.url}/services/${name}/stop`, { method:"POST", headers:{"X-Auth-Token":token} }); } catch {}
    setTimeout(fetchData, 2000);
  };
  const handleTruncate = (svcName, logPath, logFile) => {
    setTruncateConfirm({svcName, logPath, logFile});
  };
  const doTruncate = async () => {
    if (!truncateConfirm) return;
    const {svcName, logPath, logFile} = truncateConfirm;
    setTruncateConfirm(null);
    try {
      const r = await fetch(`${cfg.url}/services/${svcName}/truncate-log`, {
        method:"POST",
        headers:{"X-Auth-Token":token, "Content-Type":"application/json"},
        body: JSON.stringify({path: logPath})
      });
      const d = await r.json();
      if (d.message) setTimeout(fetchData, 1000);
    } catch(e) { console.error(e); }
  };

  const handleSelect = (svc) => {
    const next = selected?.name === svc.name ? null : svc;
    setSelected(next);
    if (next) fetchLogs(next.name);
  };

  useEffect(() => {
    fetchData();
    const id = setInterval(fetchData, 15000);
    return () => clearInterval(id);
  }, [fetchData]);

  const [sortBy, setSortBy] = useState("cpu");
  const [truncateConfirm, setTruncateConfirm] = useState(null);
  const [truncateHistory, setTruncateHistory] = useState([]);
  const [showTruncateHistory, setShowTruncateHistory] = useState(false);
  const [watchdogHistory, setWatchdogHistory] = useState([]);
  const [showWatchdogHistory, setShowWatchdogHistory] = useState(false);

  const fetchTruncateHistory = async () => {
    try {
      const r = await fetch(`${cfg.url}/truncate-history`, { headers: {"X-Auth-Token": token} });
      if (r.ok) { const d = await r.json(); setTruncateHistory(d.history||[]); }
    } catch {}
  };

  const fetchWatchdogHistory = async () => {
    try {
      let history = [];
      // Try docker watchdog history first
      const r1 = await fetch(`${cfg.url}/docker/watchdog-history`, { headers: {"X-Auth-Token": token} });
      if (r1.ok) { const d1 = await r1.json(); history = d1.history||[]; }
      // If empty, try generic watchdog history
      if (history.length === 0) {
        const r2 = await fetch(`${cfg.url}/watchdog-history`, { headers: {"X-Auth-Token": token} });
        if (r2.ok) { const d2 = await r2.json(); history = d2.history||[]; }
      }
      setWatchdogHistory(history);
    } catch {}
  };

  const svcs     = data?.services || [];
  if (data === null) return (
    <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",
      justifyContent:"center",gap:20,minHeight:300}}>
      <div style={{width:48,height:48,border:`4px solid ${cfg.accent}30`,
        borderTop:`4px solid ${cfg.accent}`,borderRadius:"50%",
        animation:"spin 1s linear infinite"}}/>
      <div style={{fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:600,
        color:cfg.accent}}>Please wait... ⏳</div>
      <div style={{fontFamily:"'Inter',sans-serif",fontSize:13,color:theme.textMuted}}>
        Service metrics on the way
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  const filtered = svcs
    .filter(s => {
      const mf = filter==="all" || s.status===filter || (filter==="running" && s.status==="active");
      const ms = !search || s.name.toLowerCase().includes(search.toLowerCase()) ||
                 (s.description||"").toLowerCase().includes(search.toLowerCase());
      return mf && ms;
    })
    .sort((a,b) => {
      if (sortBy==="cpu") {
        const av = parseFloat(a.cpu)||0;
        const bv = parseFloat(b.cpu)||0;
        return bv - av;
      }
      if (sortBy==="mem") {
        const parse = v => {
          if (!v||v==="N/A") return 0;
          const n = parseFloat(v);
          if (/GiB/i.test(v)) return n*1024;
          if (/MiB|MB/i.test(v)) return n;
          if (/KiB|KB/i.test(v)) return n/1024;
          return n;
        };
        return parse(b.memory) - parse(a.memory);
      }
      if (sortBy==="mem_pct") {
        return (parseFloat(b.mem_pct)||0) - (parseFloat(a.mem_pct)||0);
      }
      if (sortBy==="name") {
        return a.name.localeCompare(b.name);
      }
      if (sortBy==="status") {
        const order = {running:0,active:0,failed:1,stopped:2,unknown:3};
        return (order[a.status]??3) - (order[b.status]??3);
      }
      return 0;
    });
  const sum = data?.summary || {};

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",background:theme.bg,overflow:"hidden"}}>

      {/* agent status bar */}
      <div style={{padding:"8px 20px",borderBottom:`1px solid ${theme.border}`,
        display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0,
        background:theme.bgCard}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{width:8,height:8,borderRadius:"50%",display:"block",
            background:offline?"#ef4444":cfg.accent,
            boxShadow:offline?`0 0 8px #ef4444`:`0 0 8px ${cfg.accent}`}}/>
          <span style={{fontFamily:"'Inter',sans-serif",fontSize:16,color:theme.textSub,fontWeight:500}}>
            {cfg.label} · {cfg.url.split("/")[2]}
          </span>
          {offline && <span style={{fontSize:15,color:"#ef4444",background:"#ef444415",
            border:"1px solid #ef444430",padding:"2px 8px",borderRadius:4,fontWeight:700,
            fontFamily:"'Inter',sans-serif"}}>OFFLINE</span>}
        </div>
        <span style={{fontSize:14,color:theme.textMuted,fontFamily:"'Inter',sans-serif"}}>
          {lastUp ? `Updated ${lastUp.toLocaleTimeString()}` : "Connecting..."}
        </span>
      </div>

      {/* server metrics */}
      <ServerMetrics apiUrl={cfg.url} accent={cfg.accent} token={token} theme={theme}/>

      {/* summary bar */}
      {data && (
        <div style={{display:"flex",borderBottom:`1px solid ${theme.border}`,
          background:theme.summaryBg,flexShrink:0}}>
          {[["TOTAL",sum.total,theme.textSub],["RUNNING",sum.running,"#10b981"],
            ["STOPPED",sum.stopped,theme.textMuted],["FAILED",sum.failed,"#ef4444"]].map(([l,v,c],i,arr)=>(
            <div key={l} style={{flex:1,padding:"12px 0",textAlign:"center",
              borderRight:i<arr.length-1?`1px solid ${theme.border}`:"none"}}>
              <div style={{fontSize:24,fontFamily:"'Inter',sans-serif",color:c,fontWeight:800,lineHeight:1}}>{v??0}</div>
              <div style={{fontSize:15,color:theme.textMuted,letterSpacing:".1em",marginTop:3,
                fontFamily:"'Inter',sans-serif",fontWeight:600}}>{l}</div>
            </div>
          ))}
        </div>
      )}

      {/* offline state */}
      {offline && !data && (
        <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:14}}>
          <div style={{width:48,height:48,borderRadius:12,background:"#ef444415",
            border:"1px solid #ef444430",display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:22}}>⚠</div>
          <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,color:"#ef4444",fontWeight:600}}>Agent Offline</div>
          <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,color:theme.textMuted}}>{cfg.url}</div>
        </div>
      )}

      {/* Truncate History Button + Panel */}
      <div style={{padding:"6px 16px 0"}}>
        <button onClick={()=>{setShowTruncateHistory(v=>!v);fetchTruncateHistory();}}
          style={{fontSize:11,padding:"4px 12px",borderRadius:6,cursor:"pointer",
            background:showTruncateHistory?"rgba(167,139,250,0.15)":theme.inputBg,
            border:`1px solid ${showTruncateHistory?"#a78bfa":theme.border}`,
            color:showTruncateHistory?"#a78bfa":theme.textMuted,
            fontFamily:"'Inter',sans-serif",fontWeight:600}}>
          📜 Truncate History
        </button>
        <button onClick={()=>{setShowWatchdogHistory(v=>!v);fetchWatchdogHistory();}}
          style={{fontSize:11,padding:"4px 12px",borderRadius:6,cursor:"pointer",
            background:showWatchdogHistory?"rgba(239,68,68,0.15)":theme.inputBg,
            border:`1px solid ${showWatchdogHistory?"#ef4444":theme.border}`,
            color:showWatchdogHistory?"#ef4444":theme.textMuted,
            fontFamily:"'Inter',sans-serif",fontWeight:600}}>
          🔄 Restart History
        </button>
      </div>
      {/* Truncate History Panel */}
      {showTruncateHistory && (
        <div style={{margin:"8px 16px",background:theme.bgCard,
          border:"1px solid #a78bfa40",borderRadius:10,padding:12}}>
          <div style={{fontSize:12,fontWeight:700,color:"#a78bfa",marginBottom:8}}>
            📜 Log Truncate History
          </div>
          {truncateHistory.length===0 ? (
            <div style={{fontSize:11,color:theme.textMuted}}>No truncations yet</div>
          ) : truncateHistory.map((h,i)=>(
            <div key={i} style={{display:"grid",
              gridTemplateColumns:"130px 1fr 80px 80px 80px 50px",
              gap:8,padding:"5px 8px",fontSize:11,
              background:i%2===0?theme.inputBg:"transparent",borderRadius:4,
              fontFamily:"'JetBrains Mono',monospace"}}>
              <span style={{color:theme.textMuted}}>{h.time}</span>
              <span style={{color:theme.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{h.service}</span>
              <span style={{color:"#ef4444"}}>{h.before}</span>
              <span style={{color:"#10b981"}}>{h.after}</span>
              <span style={{color:"#06b6d4"}}>-{h.saved}</span>
              <span style={{color:h.auto?"#f59e0b":"#a78bfa",fontSize:9,fontWeight:700}}>
                {h.auto?"AUTO":"MANUAL"}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Watchdog Restart History */}
      {showWatchdogHistory && (
        <div style={{margin:"8px 16px",background:theme.bgCard,
          border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:12}}>
          <div style={{fontSize:12,fontWeight:700,color:"#ef4444",marginBottom:8}}>
            🔄 Auto-Restart History
          </div>
          {watchdogHistory.length===0 ? (
            <div style={{fontSize:11,color:theme.textMuted}}>No restarts recorded yet</div>
          ) : watchdogHistory.map((h,i)=>(
            <div key={i} style={{display:"grid",
              gridTemplateColumns:"140px 1fr 1fr 50px",
              gap:8,padding:"6px 8px",fontSize:11,
              background:i%2===0?theme.inputBg:"transparent",borderRadius:4,
              fontFamily:"'JetBrains Mono',monospace",marginBottom:2}}>
              <span style={{color:theme.textMuted}}>{h.time}</span>
              <span style={{color:"#ef4444",fontWeight:600}}>{h.service||h.container}</span>
              <span style={{color:"#f59e0b"}}>{h.reason}</span>
              <span style={{color:h.auto?"#a78bfa":"#06b6d4",fontSize:9,fontWeight:700}}>
                {h.auto?"AUTO":"MANUAL"}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* service list */}
      {data && (
        <div style={{flex:1,display:"grid",gridTemplateColumns:selected?"1fr 520px":"1fr",overflow:"hidden",minHeight:0}}>
          <div style={{display:"flex",flexDirection:"column",overflow:"hidden",minHeight:0}}>
            {/* sort bar */}
            <div style={{display:"flex",alignItems:"center",gap:6,padding:"8px 20px",
              borderBottom:`1px solid ${theme.border}`,background:theme.bgCard,flexShrink:0}}>
              <span style={{fontSize:16,color:theme.textMuted,fontFamily:"'Inter',sans-serif",
                fontWeight:600,marginRight:4}}>SORT BY:</span>
              {[["cpu","⚡ CPU"],["mem","💾 Memory"],["mem_pct","📊 Mem %"],
                ["name","🔤 Name"],["status","● Status"]].map(([k,l])=>(
                <button key={k} onClick={()=>setSortBy(k)} style={{
                  fontSize:16,padding:"3px 10px",borderRadius:5,cursor:"pointer",
                  fontFamily:"'Inter',sans-serif",fontWeight:600,
                  background:sortBy===k?`${cfg.accent}20`:theme.inputBg,
                  border:`1px solid ${sortBy===k?`${cfg.accent}50`:theme.border}`,
                  color:sortBy===k?cfg.accent:theme.textMuted,
                  transition:"all .15s",
                }}>{l}</button>
              ))}
              <span style={{fontSize:16,color:theme.textMuted,marginLeft:"auto",
                fontFamily:"'Inter',sans-serif"}}>
                {filtered.length} services · highest first
              </span>
            </div>
            <div style={{overflowY:"auto",flex:1}}>
            {filtered.map(s => (
              <ServiceRow key={s.name} svc={s} selected={selected?.name===s.name}
                onClick={handleSelect} accent={cfg.accent} theme={theme} envKey={envKey} token={token}/>
            ))}
            {filtered.length === 0 && (
              <div style={{textAlign:"center",padding:"60px 0",color:theme.textMuted,
                fontFamily:"'Inter',sans-serif",fontSize:15}}>No services match</div>
            )}
            </div>
          </div>
          {selected && (
            <DetailPane svc={svcs.find(s=>s.name===selected.name)||selected}
              logs={logs} onClose={()=>setSelected(null)}
              onRestart={handleRestart} onLoadMore={handleLoadMore} onStart={handleStart} onStop={handleStop} onTruncate={handleTruncate} accent={cfg.accent} theme={theme}/>
          )}
          {truncateConfirm&&(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",
              zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <div style={{background:theme.bgCard,borderRadius:14,padding:"28px 32px",
                border:`1px solid ${theme.border}`,maxWidth:400,width:"90%",
                boxShadow:"0 20px 60px rgba(0,0,0,0.5)"}}>
                <div style={{fontSize:16,fontWeight:700,color:theme.text,
                  fontFamily:"'Inter',sans-serif",marginBottom:8}}>
                  🗑 Truncate Log File
                </div>
                <div style={{fontSize:16,color:"#94a3b8",fontFamily:"'Inter',sans-serif",marginBottom:6}}>
                  This will permanently clear all contents of:
                </div>
                <div style={{fontSize:15,color:"#ef4444",fontFamily:"'Fira Code',monospace",
                  background:"rgba(239,68,68,0.08)",borderRadius:6,padding:"8px 12px",
                  border:"1px solid rgba(239,68,68,0.2)",marginBottom:20,wordBreak:"break-all"}}>
                  📄 {truncateConfirm.logFile}
                </div>
                <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
                  <button onClick={()=>setTruncateConfirm(null)} style={{
                    padding:"8px 20px",borderRadius:8,cursor:"pointer",fontSize:16,
                    fontFamily:"'Inter',sans-serif",fontWeight:600,
                    background:theme.inputBg,border:`1px solid ${theme.border}`,
                    color:theme.textMuted}}>Cancel</button>
                  <button onClick={doTruncate} style={{
                    padding:"8px 20px",borderRadius:8,cursor:"pointer",fontSize:16,
                    fontFamily:"'Inter',sans-serif",fontWeight:600,
                    background:"rgba(239,68,68,0.15)",border:"1px solid rgba(239,68,68,0.4)",
                    color:"#ef4444"}}>🗑 Truncate</button>
                </div>
              </div>
            </div>
          )}
          )}
        </div>
      )}
    </div>
  );
}

// ── APP ──────────────────────────────────────────────────

// ── SERVER PICKER ─────────────────────────────────────────
function ServerPicker({ tab, setTab, theme, cfg, env }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);



  const groups = (env)==="inhouse" ? [
    { label:"🏠 Overview",        keys:["home"] },
    { label:"🏢 In-House Servers", keys:["ihodoo","ihsim1","ihsim2","ihjenkins","ihnexus","ihvpn","ihges"] },
    { label:"📊 Tools",           keys:["history","users","errors"] },
  ] : (env)==="iccc-erode" ? [
    { label:"🏠 Overview",       keys:["home"] },
    { label:"🏙 ICCC Erode",     keys:["iccceroded","iccceromysql"] },
    { label:"📊 Tools",          keys:["history","users","errors"] },
  ] : (env)==="iccc-trichy" ? [
    { label:"🏠 Overview",       keys:["home"] },
    { label:"🏙 ICCC Trichy",    keys:["iccctrid","iccctrimysql"] },
    { label:"📊 Tools",          keys:["history","users","errors"] },
  ] : (env||"tnpdcl")==="fsa" ? [
    { label:"🏠 Overview",       keys:["home"] },
    { label:"🏭 FSA Production", keys:["fsascript","fsadocker1","fsaevents","fsarabbitmq","fsakafkazk","fsaconfig","fsagps"] },
    { label:"🗄 Database",       keys:["fsadb"] },
    { label:"📊 Tools",          keys:["history","users","errors","fsaonedash"] },
  ] : [
    { label:"🏠 Overview",    keys:["home"] },
    { label:"🧪 Development", keys:["dev","devdocker"] },
    { label:"⚡ Production",  keys:["prod","device","micro","ps3","ep","reproc","dataproc","tnpdcldock2"] },

    { label:"🗄 Database",    keys:["db"] },
    { label:"📊 Tools",       keys:["kafka","redis","mqtt","docker","history","users","errors","onedash","ai","deploy"] },
  ];
  const current = SERVERS[tab];

  return (
    <div ref={ref} style={{position:"relative",padding:"6px 16px",display:"flex",alignItems:"center",gap:8}}>
      {/* Current tab pill */}
      <div style={{display:"flex",alignItems:"center",gap:6,
        background:current?`${cfg.accent}12`:"rgba(255,255,255,0.05)",
        border:`1px solid ${current?cfg.accent+"40":"rgba(255,255,255,0.15)"}`,
        borderRadius:8,padding:"5px 14px",cursor:"pointer",
        fontFamily:"'Inter',sans-serif",fontSize:13,fontWeight:700,
        color:current?cfg.accent:"#94a3b8",
        userSelect:"none",minWidth:180,justifyContent:"space-between"}}
        onClick={()=>setOpen(o=>!o)}>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          {current
            ? <span style={{width:7,height:7,borderRadius:"50%",background:cfg.accent,boxShadow:`0 0 8px ${cfg.accent}`}}/>
            : <span style={{fontSize:13}}>🖥</span>
          }
          <span>{current?.label || "Select Server..."}</span>
        </div>
        <span style={{fontSize:10,opacity:.6,marginLeft:8}}>{open?"▲":"▼"}</span>
      </div>

      {/* Dropdown */}
      {open && (
        <div style={{
          position:"absolute",top:"calc(100% + 6px)",left:16,zIndex:9999,
          background:theme.bgCard,border:`1px solid ${theme.border}`,
          borderRadius:14,padding:16,minWidth:520,
          boxShadow:"0 20px 60px rgba(0,0,0,0.5)",
          fontFamily:"'Inter',sans-serif",
        }}>
          <div style={{marginBottom:16,paddingBottom:12,borderBottom:`1px solid ${theme.border}`}}>
            <div style={{fontSize:16,fontWeight:800,color:theme.text,
              fontFamily:"'Inter',sans-serif",marginBottom:4}}>
              🖥 Select Server to Monitor
            </div>
            <div style={{fontSize:12,color:theme.textMuted,fontFamily:"'Inter',sans-serif"}}>
              Choose a server or tool from the list below
            </div>
          </div>
          {groups.map(({label,keys})=>(
            <div key={label} style={{marginBottom:12}}>
              <div style={{fontSize:10,fontWeight:700,color:theme.textMuted,
                letterSpacing:".1em",marginBottom:8}}>{label}</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {keys.filter(k=>SERVERS[k]).map(key=>{
                  const s = SERVERS[key];
                  const isActive = tab===key;
                  return (
                    <button key={key}
                      onClick={()=>{ setTab(key); setOpen(false); }}
                      style={{
                        display:"flex",alignItems:"center",gap:7,
                        background:isActive?`${s.accent}18`:theme.inputBg,
                        border:`2px solid ${isActive?s.accent:theme.border}`,
                        borderRadius:8,padding:"7px 14px",cursor:"pointer",
                        fontSize:12,fontWeight:isActive?700:500,
                        color:isActive?s.accent:theme.text,
                        transition:"all .15s",
                      }}>
                      <span style={{width:7,height:7,borderRadius:"50%",flexShrink:0,
                        background:isActive?s.accent:"#475569",
                        boxShadow:isActive?`0 0 8px ${s.accent}`:"none"}}/>
                      {s.label}
                      <span style={{fontSize:10,padding:"1px 6px",borderRadius:4,
                        background:isActive?`${s.accent}25`:theme.badge,
                        color:isActive?s.accent:theme.textMuted,fontWeight:700}}>
                        {s.tag}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function useIsMobile() {
  const [m, setM] = useState(typeof window !== "undefined" && window.innerWidth < 820);
  useEffect(() => {
    const onR = () => setM(window.innerWidth < 820);
    window.addEventListener("resize", onR);
    return () => window.removeEventListener("resize", onR);
  }, []);
  return m;
}


function cleanPorts(ports) {
  if (!ports || !ports.length) return [];
  const hp = [...new Set(ports.map(p => {
    const m = String(p).match(/(\d+)\/tcp/);
    return m ? m[1] : (String(p).match(/^(\d+)/) || [])[1];
  }).filter(Boolean))];
  return hp;
}

export default function App() {
  const isMobile = useIsMobile();

  const [token,     setToken]     = useState(()=>sessionStorage.getItem("bn360_token")||null);
  const [user,      setUser]      = useState(()=>sessionStorage.getItem("bn360_user")||null);
  const [role,      setRole]      = useState(()=>sessionStorage.getItem("bn360_role")||null);
  const [mode,      setMode]      = useState(()=>sessionStorage.getItem("bn360_mode")||null);
  const [allowedEnvs,setAllowedEnvs]=useState(()=>{try{const e=sessionStorage.getItem("bn360_envs");return e&&e!=="null"?JSON.parse(e):null;}catch{return null;}});
  const [env,       setEnv]       = useState(()=>sessionStorage.getItem("bn360_env")||null);
  const [tab,       setTab]       = useState(()=>sessionStorage.getItem("bn360_tab")||"dev");
  const [filter,    setFilter]    = useState("all");
  const [search,    setSearch]    = useState("");
  const [themeName, setThemeName] = useState(()=>localStorage.getItem("bn360_theme")||"neumorph");
  const [selDev,    setSelDev]    = useState(null);
  const [selProd,   setSelProd]   = useState(null);
  const [selDevice, setSelDevice] = useState(null);
  const [selMicro,  setSelMicro]  = useState(null);
  const [selPs3,    setSelPs3]    = useState(null);
  const [selEp,     setSelEp]     = useState(null);
  const [selReproc,   setSelReproc]   = useState(null);
  const [selDataproc,  setSelDataproc]  = useState(null);
  const [selDevdocker,    setSelDevdocker]    = useState(null);
  const [selTnpdcldock2,  setSelTnpdcldock2]  = useState(null);
  const [selFsascript,   setSelFsascript]   = useState(null);
  const [selFsadocker1,  setSelFsadocker1]  = useState(null);
  const [selFsaevents,   setSelFsaevents]   = useState(null);
  const [selFsarabbitmq, setSelFsarabbitmq] = useState(null);
  const [selFsakafkazk, setSelFsakafkazk] = useState(null);
  const [selFsaconfig, setSelFsaconfig] = useState(null);
  const [selFsagps, setSelFsagps] = useState(null);
  const [selIccceroded, setSelIccceroded] = useState(null);
  const [selIccceromysql, setSelIccceromysql] = useState(null);
  const [selIccctrid, setSelIccctrid] = useState(null);
  const [selIccctrimysql, setSelIccctrimysql] = useState(null);
  const [selIhodoo, setSelIhodoo] = useState(null);
  const [selIhsim1, setSelIhsim1] = useState(null);
  const [selIhsim2, setSelIhsim2] = useState(null);
  const [selIhjenkins, setSelIhjenkins] = useState(null);
  const [selIhnexus, setSelIhnexus] = useState(null);
  const [selIhvpn, setSelIhvpn] = useState(null);
  const [selIhges, setSelIhges] = useState(null);

  const theme = THEMES[themeName] || THEMES.midnight || Object.values(THEMES)[0];
  const isDark = ["midnight","slate","cyberpunk","volcano","forest","ocean","aurora","tech"].includes(themeName);
  const cfg   = SERVERS[tab];

  const handleLogin = (tok, usr, rl, envs) => {
    setToken(tok); setUser(usr);
    setRole(rl||"readonly"); setAllowedEnvs(envs||null);
    sessionStorage.setItem("bn360_token", tok);
    sessionStorage.setItem("bn360_user", usr);
    sessionStorage.setItem("bn360_role", rl||"readonly");
    sessionStorage.setItem("bn360_envs", JSON.stringify(envs||null));
    if (envs && envs.length===1){ setEnv(envs[0]); sessionStorage.setItem("bn360_env",envs[0]); }
  };
  const handleLogout = async () => {
    try { await fetch("/auth/logout",{method:"POST",headers:{"X-Auth-Token":token}}); } catch {}
    setToken(null); setUser(null);
  };

  if (!token) return <LoginScreen onLogin={handleLogin} theme={theme}/>;
  if (!mode) return <ModeChoice user={user} onSelect={(m)=>{setMode(m);sessionStorage.setItem("bn360_mode",m);}} onLogout={()=>{setToken(null);setUser(null);setEnv(null);setMode(null);sessionStorage.clear();}}/>;
  if (mode==="deployment") return <div style={{height:"100vh",display:"flex",flexDirection:"column",background:theme.bg}}><div style={{flexShrink:0,padding:"12px 24px",background:theme.topbar,borderBottom:`1px solid ${theme.border}`,display:"flex",alignItems:"center",gap:12}}><span style={{fontFamily:"monospace",fontWeight:800,color:theme.text}}>BN<span style={{color:"#0284c7"}}>360</span> Deployment</span><button onClick={()=>{setMode(null);sessionStorage.removeItem("bn360_mode");}} style={{marginLeft:"auto",background:theme.bgCard,border:`1px solid ${theme.border}`,color:theme.text,borderRadius:8,padding:"6px 14px",cursor:"pointer",fontSize:12,fontWeight:600}}>← Back</button><button onClick={()=>{setToken(null);setUser(null);setEnv(null);setMode(null);sessionStorage.clear();}} style={{background:theme.bgCard,border:`1px solid ${theme.border}`,color:theme.textMuted,borderRadius:8,padding:"6px 14px",cursor:"pointer",fontSize:12}}>Logout</button></div><DeployPanel theme={theme} role={role} user={user}/></div>;
  if (!env) return (
    <EnvSelector user={user} role={role} allowedEnvs={allowedEnvs}
      onSelect={(e)=>{setEnv(e);sessionStorage.setItem("bn360_env",e);const t=e==="fsa"?"fsascript":e==="iccc-erode"?"iccceroded":e==="iccc-trichy"?"iccctrid":e==="inhouse"?"ihodoo":"home";setTab(t);sessionStorage.setItem("bn360_tab",t);}}
      onLogout={()=>{setToken(null);setUser(null);setEnv(null);setRole(null);setAllowedEnvs(null);sessionStorage.clear();}}
    />
  );

  return (
    <div data-theme={themeName} style={{height:"100vh",display:"flex",flexDirection:"column",
      background:theme.bg,color:theme.text,overflow:"hidden",position:"relative",
      fontFamily:"'Inter',sans-serif"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Fira+Code:wght@400;600&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        ::-webkit-scrollbar{width:5px;}
        ::-webkit-scrollbar-track{background:transparent;}
        ::-webkit-scrollbar-thumb{background:${theme.scrollThumb};border-radius:4px;}
        @keyframes ripple{0%{transform:scale(1);opacity:.3}100%{transform:scale(2.6);opacity:0}}
        @keyframes fadeSlide{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}

        /* ===== NEUMORPHISM THEME - soft raised cards ===== */
        [data-theme="neumorph"] div[style*="border-radius"][style*="rgb(234, 239, 246)"],
        [data-theme="neumorph"] div[style*="border-radius"][style*="#eaeff6"] {
          box-shadow: 5px 5px 11px #c3ccd9, -5px -5px 11px #ffffff !important;
          border-color: transparent !important;
        }
        /* generic cards: any element using the card bg color */
        [data-theme="neumorph"] [style*="rgb(234, 239, 246)"] {
          box-shadow: 5px 5px 11px #c3ccd9, -5px -5px 11px #ffffff !important;
          border: none !important;
        }
        /* inputs / metric wells (inset look) */
        [data-theme="neumorph"] input,
        [data-theme="neumorph"] [style*="rgb(214, 220, 230)"],
        [data-theme="neumorph"] [style*="rgb(230, 235, 242)"] {
          box-shadow: inset 3px 3px 6px #c3ccd9, inset -3px -3px 6px #ffffff !important;
          border: none !important;
        }
        /* top bar - subtle raised */
        [data-theme="neumorph"] [style*="rgb(224, 229, 236)"] {
          border-color: transparent !important;
        }
        /* buttons hover lift */
        [data-theme="neumorph"] button:hover {
          box-shadow: 6px 6px 12px #c3ccd9, -6px -6px 12px #ffffff !important;
        }

        /* ===== NEUMORPHISM DARK ===== */
        [data-theme="neumorphdark"] [style*="rgb(50, 54, 63)"] {
          box-shadow: 5px 5px 11px #202329, -5px -5px 11px #3a3f4a !important;
          border: none !important;
        }
        [data-theme="neumorphdark"] input,
        [data-theme="neumorphdark"] [style*="rgb(46, 49, 58)"] {
          box-shadow: inset 3px 3px 6px #202329, inset -3px -3px 6px #3a3f4a !important;
          border: none !important;
        }
        [data-theme="neumorphdark"] [style*="rgb(40, 43, 51)"] {
          border-color: transparent !important;
        }
        [data-theme="neumorphdark"] button:hover {
          box-shadow: 6px 6px 12px #202329, -6px -6px 12px #3a3f4a !important;
        }
      `}</style>

      {/* ── TOP BAR ── */}
      <div style={{flexShrink:0,background:theme.topbar,
        borderBottom:`1px solid ${theme.border}`,
        boxShadow:isDark?"0 2px 8px rgba(0,0,0,0.4)":"0 2px 8px rgba(0,0,0,0.08)"}}>
        {/* ROW 1 */}
        <div style={{padding:"10px 16px",display:"flex",alignItems:"center",
          gap:8,borderBottom:`1px solid ${theme.border}`,flexWrap:"wrap"}}>
          <span style={{fontFamily:"'Inter',sans-serif",fontSize:18,fontWeight:800,letterSpacing:"-.02em",marginRight:8}}>
            <span style={{color:"#3b82f6"}}>BN</span>
            <span style={{color:theme.text}}>360</span>
            <span style={{color:"#10b981"}}>★</span>
          </span>
          <div style={{width:1,height:20,background:theme.border,flexShrink:0}}/>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {[["all","All"],["running","▶ Running"],["stopped","■ Stopped"],["failed","✕ Failed"]].map(([k,l])=>(
              <button key={k} onClick={()=>setFilter(k)} style={{
                background:filter===k?`${cfg.accent}18`:theme.inputBg,
                border:`1px solid ${filter===k?`${cfg.accent}50`:theme.border}`,
                color:filter===k?cfg.accent:theme.textMuted,
                borderRadius:6,padding:"5px 12px",cursor:"pointer",
                fontFamily:"'Inter',sans-serif",fontSize:12,fontWeight:600,
                transition:"all .15s",whiteSpace:"nowrap",
              }}>{l}</button>
            ))}
          </div>
          <GlobalSearch token={token} theme={theme}
            onNavigate={(server, svcName) => {
              setTab(server);
              sessionStorage.setItem("bn360_tab", server);
              setSearch(svcName);
            }}/>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="🔍 Search this server..."
            style={{background:theme.inputBg,border:`1px solid ${theme.border}`,
              color:theme.text,borderRadius:6,padding:"6px 12px",
              fontFamily:"'Inter',sans-serif",fontSize:13,outline:"none",
              flex:"1 1 160px",minWidth:120,maxWidth:260,transition:"border .2s"}}
            onFocus={e=>e.target.style.borderColor=cfg.accent}
            onBlur={e=>e.target.style.borderColor=theme.border}/>
          <div style={{flex:1}}/>
          <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
            {false && (<select value={themeName}
              onChange={e=>{setThemeName(e.target.value);localStorage.setItem("bn360_theme",e.target.value);}}
              style={{background:theme.bgCard,border:`1px solid ${theme.border}`,
                color:theme.text,borderRadius:6,padding:"5px 10px",cursor:"pointer",
                fontFamily:"'Inter',sans-serif",fontSize:12,fontWeight:600,outline:"none",
                colorScheme:isDark?"dark":"light",minWidth:150}}>
              {Object.entries(THEMES).map(([k,t])=>(
                <option key={k} value={k}>{t.label||k}</option>
              ))}
            </select>)}
            <button onClick={()=>{const nt=themeName==="neumorphdark"?"neumorph":"neumorphdark";setThemeName(nt);localStorage.setItem("bn360_theme",nt);}}
              title="Toggle light/dark"
              style={{background:theme.bgCard,border:`1px solid ${theme.border}`,color:theme.text,
                borderRadius:8,padding:"6px 12px",cursor:"pointer",fontSize:13,fontWeight:600,
                fontFamily:"'Inter',sans-serif",outline:"none"}}>
              {themeName==="neumorphdark"?"☀️ Light":"◑ Dark"}
            </button>
            <AlertsPanel theme={theme} token={token}/>
            {role==="readonly"&&(
              <span style={{fontSize:11,fontWeight:700,padding:"4px 10px",borderRadius:6,
                background:"rgba(245,158,11,0.1)",border:"1px solid rgba(245,158,11,0.3)",
                color:"#f59e0b",fontFamily:"'Inter',sans-serif"}}>👁 VIEW ONLY</span>
            )}
            <button onClick={()=>{setEnv(null);sessionStorage.removeItem("bn360_env");}} style={{
              background:"rgba(59,130,246,0.1)",border:"1px solid rgba(59,130,246,0.3)",
              color:"#3b82f6",borderRadius:6,padding:"5px 12px",cursor:"pointer",
              fontFamily:"'Inter',sans-serif",fontSize:12,fontWeight:600,whiteSpace:"nowrap",
            }}>{env==="fsa"?"🏭 FSA":env==="iccc-erode"?"🏙 ICCC Erode":env==="iccc-trichy"?"🏙 ICCC Trichy":"⚡ TNPDCL"}</button>
            <button onClick={()=>{setToken(null);setUser(null);setEnv(null);setRole(null);setAllowedEnvs(null);sessionStorage.clear();}} style={{
              background:theme.inputBg,border:`1px solid ${theme.border}`,
              color:theme.textMuted,borderRadius:6,padding:"5px 12px",cursor:"pointer",
              fontFamily:"'Inter',sans-serif",fontSize:12,fontWeight:600,whiteSpace:"nowrap",
            }}>⎋ Logout</button>
          </div>
        </div>
        {/* ROW 2: Server picker */}
        <ServerPicker tab={tab} setTab={(k)=>{setTab(k);sessionStorage.setItem("bn360_tab",k);}} theme={theme} cfg={cfg} env={env}/>
      </div>
      <div style={{flex:1,overflow:"auto",minHeight:0,animation:"fadeSlide .2s ease"}}>
        {tab==="db"     && <DBPanel token={token} theme={theme} role={role}/>}
        {tab==="fsadb"  && <FSADBPanel token={token} theme={theme} role={role}/>}
        {tab==="home"   && <HomePanel token={token} theme={theme} env={env} setTab={(k)=>{setTab(k);sessionStorage.setItem("bn360_tab",k);}}/>}
        {tab==="onedash" && <OneDashPanel token={token} theme={theme} role={role}/>}
        {tab==="ai" && <AIAssistantPanel token={token} theme={theme}/>}
        {tab==="assets" && <AssetsPanel theme={theme}/>}
        {tab==="deploy" && <DeployPanel theme={theme} role={role} user={user}/>}
        {tab==="fsaonedash" && <FSAOneDashPanel token={token} theme={theme} role={role}/>}
        {tab==="history"&& <HistoryPanel token={token} theme={theme} role={role}/>}
        {tab==="errors" && <ErrorConsole env={env} token={token} theme={theme} role={role}/>}
        {tab==="kafka"   && <KafkaPanel token={token} theme={theme} env={env}/>}
        {tab==="redis"   && <RedisPanel token={token} theme={theme}/>}
        {tab==="mqtt"    && <MqttPanel  token={token} theme={theme}/>}
        {tab==="docker"  && <DockerPanel token={token} theme={theme} env={env}/>}
        {tab==="users"   && role==="admin" && <UserPanel token={token} theme={theme} currentUser={user}/>}
        {tab==="users"   && role!=="admin" && (
          <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",
            flexDirection:"column",gap:12}}>
            <div style={{fontSize:32}}>🔒</div>
            <div style={{fontFamily:"'Inter',sans-serif",fontSize:15,color:theme.textMuted}}>
              Admin access required
            </div>
          </div>
        )}
        {!["db","fsadb","history","users"].includes(tab) && !SERVERS[tab] && (
          <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",
            justifyContent:"center",gap:24,background:theme.bg}}>
            <style>{`
              @keyframes pulse-ring{0%{transform:scale(.8);opacity:.8}70%{transform:scale(1.3);opacity:0}100%{transform:scale(1.3);opacity:0}}
              @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
              @keyframes shimmer{0%{opacity:.5}50%{opacity:1}100%{opacity:.5}}
            `}</style>
            <div style={{position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <div style={{position:"absolute",width:90,height:90,borderRadius:"50%",
                background:"rgba(59,130,246,0.15)",animation:"pulse-ring 2s ease infinite"}}/>
              <div style={{position:"absolute",width:70,height:70,borderRadius:"50%",
                background:"rgba(59,130,246,0.1)",animation:"pulse-ring 2s ease .4s infinite"}}/>
              <div style={{fontSize:40,animation:"float 3s ease infinite"}}>🖥</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{
                fontSize:28,fontWeight:800,
                background:"linear-gradient(135deg,#38bdf8,#3b82f6,#10b981)",
                WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",
                fontFamily:"'Inter',sans-serif",letterSpacing:"-.02em",
                animation:"shimmer 2s ease infinite",marginBottom:8,
              }}>Select a Server</div>
              <div style={{fontSize:14,color:theme.textMuted,fontFamily:"'Inter',sans-serif",marginBottom:4}}>
                Click the server picker above to get started
              </div>
              <div style={{fontSize:13,color:"#475569",fontFamily:"'Inter',sans-serif"}}>
                Monitor services, metrics, logs and more
              </div>
            </div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap",justifyContent:"center",maxWidth:500}}>
              {Object.entries(SERVERS).filter(([k])=>!["history","users"].includes(k)).map(([key,s])=>(
                <div key={key} style={{
                  display:"flex",alignItems:"center",gap:6,
                  background:`${s.accent}10`,border:`1px solid ${s.accent}30`,
                  borderRadius:8,padding:"6px 14px",cursor:"pointer",
                  fontFamily:"'Inter',sans-serif",fontSize:12,fontWeight:600,
                  color:s.accent,transition:"all .2s",
                }}
                onClick={()=>setTab(key)}>
                  <span style={{width:6,height:6,borderRadius:"50%",background:s.accent,
                    boxShadow:`0 0 6px ${s.accent}`}}/>
                  {s.label}
                  <span style={{fontSize:10,opacity:.7}}>{s.tag}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        {tab==="kafka"  && null}
        {tab==="dev"    && <EnvPanel key="dev"    envKey="dev"    selected={selDev}    setSelected={setSelDev}    filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="prod"   && <EnvPanel key="prod"   envKey="prod"   selected={selProd}   setSelected={setSelProd}   filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="device" && <EnvPanel key="device" envKey="device" selected={selDevice} setSelected={setSelDevice} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="micro"  && <EnvPanel key="micro"  envKey="micro"  selected={selMicro}  setSelected={setSelMicro}  filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ps3"    && <EnvPanel key="ps3"    envKey="ps3"    selected={selPs3}    setSelected={setSelPs3}    filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ep"     && <EnvPanel key="ep"     envKey="ep"     selected={selEp}     setSelected={setSelEp}     filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="reproc"   && <EnvPanel key="reproc"   envKey="reproc"   selected={selReproc}   setSelected={setSelReproc}   filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="dataproc"  && <EnvPanel key="dataproc"  envKey="dataproc"  selected={selDataproc}  setSelected={setSelDataproc}  filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="devdocker"    && <EnvPanel key="devdocker"    envKey="devdocker"    selected={selDevdocker}    setSelected={setSelDevdocker}    filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="tnpdcldock2"  && <EnvPanel key="tnpdcldock2"  envKey="tnpdcldock2"  selected={selTnpdcldock2}  setSelected={setSelTnpdcldock2}  filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="fsascript"   && <EnvPanel key="fsascript"   envKey="fsascript"   selected={selFsascript}   setSelected={setSelFsascript}   filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="fsadocker1"  && <EnvPanel key="fsadocker1"  envKey="fsadocker1"  selected={selFsadocker1}  setSelected={setSelFsadocker1}  filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="fsaevents"   && <EnvPanel key="fsaevents"   envKey="fsaevents"   selected={selFsaevents}   setSelected={setSelFsaevents}   filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="fsarabbitmq" && <EnvPanel key="fsarabbitmq" envKey="fsarabbitmq" selected={selFsarabbitmq} setSelected={setSelFsarabbitmq} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="fsakafkazk" && <EnvPanel key="fsakafkazk" envKey="fsakafkazk" selected={selFsakafkazk} setSelected={setSelFsakafkazk} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="fsaconfig" && <EnvPanel key="fsaconfig" envKey="fsaconfig" selected={selFsaconfig} setSelected={setSelFsaconfig} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="fsagps" && <EnvPanel key="fsagps" envKey="fsagps" selected={selFsagps} setSelected={setSelFsagps} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="iccceroded" && <EnvPanel key="iccceroded" envKey="iccceroded" selected={selIccceroded} setSelected={setSelIccceroded} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="iccceromysql" && <EnvPanel key="iccceromysql" envKey="iccceromysql" selected={selIccceromysql} setSelected={setSelIccceromysql} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="iccctrid" && <EnvPanel key="iccctrid" envKey="iccctrid" selected={selIccctrid} setSelected={setSelIccctrid} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="iccctrimysql" && <EnvPanel key="iccctrimysql" envKey="iccctrimysql" selected={selIccctrimysql} setSelected={setSelIccctrimysql} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ihodoo" && <EnvPanel key="ihodoo" envKey="ihodoo" selected={selIhodoo} setSelected={setSelIhodoo} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ihsim1" && <EnvPanel key="ihsim1" envKey="ihsim1" selected={selIhsim1} setSelected={setSelIhsim1} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ihsim2" && <EnvPanel key="ihsim2" envKey="ihsim2" selected={selIhsim2} setSelected={setSelIhsim2} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ihjenkins" && <EnvPanel key="ihjenkins" envKey="ihjenkins" selected={selIhjenkins} setSelected={setSelIhjenkins} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ihnexus" && <EnvPanel key="ihnexus" envKey="ihnexus" selected={selIhnexus} setSelected={setSelIhnexus} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ihvpn" && <EnvPanel key="ihvpn" envKey="ihvpn" selected={selIhvpn} setSelected={setSelIhvpn} filter={filter} search={search} token={token} theme={theme} role={role}/>}
        {tab==="ihges" && <EnvPanel key="ihges" envKey="ihges" selected={selIhges} setSelected={setSelIhges} filter={filter} search={search} token={token} theme={theme} role={role}/>}
      </div>

      {/* ── STATUS BAR ── */}
      <div style={{padding:"5px 24px",borderTop:`1px solid ${theme.border}`,
        display:"flex",justifyContent:"space-between",
        fontFamily:"'Inter',sans-serif",fontSize:14,color:theme.textMuted,
        flexShrink:0,background:theme.topbar}}>
        <span style={{fontWeight:500}}>BN360* · Bluenett Service Monitor · Auto-refresh 15s · 4 Servers</span>
        <span>dev .30 · ps1 .12 · ps2 .10 · micro .11 · © {new Date().getFullYear()} BN360 · All Rights Reserved</span>
      </div>
    </div>
  );
}
